// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"ffa2258c","334":"0dcfd979"}[chunkId] + ".chunk.js";
};